import { useMatchMedia } from '@enuygun/design-system'
import { down } from 'styled-breakpoints'
import { useBreakpoint } from 'styled-breakpoints/react-styled'

import { useUserDevice } from '../context/UserAgent'

/**
 * Cihaz tipini algılayan hook
 * @returns {Object} { isMobile, isTablet, isDesktop }
 */
const useDeviceType = () => {
  const ua = useUserDevice()
  const breakpointsSm = useBreakpoint(down('sm')) // < 768px
  const breakpointsMd = useBreakpoint(down('md')) // < 1024px

  const { sm, xs } = useMatchMedia()

  // Mobile: 768px altı veya user-agent mobile
  const isMobile = ua?.isMobile || xs || sm || breakpointsSm

  // Tablet: User-agent tablet VEYA (768px-1024px arası ve mobile değil)
  const isTablet = ua?.isTablet

  // Desktop: Ne mobile ne tablet
  const isDesktop = !isMobile && !isTablet

  return { isMobile, isTablet, isDesktop }
}

export { useDeviceType }
